
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './services/storageService.ts'; // Ensure storage bucket exists
import { Buffer } from 'buffer'; // Import Buffer properly

// Add global polyfill for browser compatibility with Node.js code
window.global = window;

// Use a partial implementation of process that satisfies TypeScript
// @ts-ignore - We're deliberately using a simplified process object for browser compatibility
window.process = window.process || { env: {} };

// Properly assign the Buffer to window.Buffer
// @ts-ignore - We're deliberately ignoring type issues for browser compatibility
window.Buffer = window.Buffer || Buffer;

// Add simple console log to debug initialization
console.log('Application initializing...');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
